<template>
  <div class="introduce" :class="{ right: right }">
    <div :style="{ background: background }">
      <div class="progress" v-show="progress < 100">
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/17.gif"
          alt=""
        />
        <span>3D模型加载中 {{ progress }}%</span>
      </div>
      <canvas
        id="threeAdd"
        class="model"
        ref="fullscreen"
      ></canvas>
      <img
        class="shadow"
        src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/16.png"
        alt=""
      />
      <div class="title">{{ title }}</div>
      <div class="line"></div>
      <div class="desc">
        {{ isMobile && descMobile ? descMobile : desc }}
      </div>
    </div>
  </div>
</template>
<script>
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

export default {
  props: {
    title: {
      type: String,
      default: '产品介绍'
    },
    descMobile: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    right: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      data: {
        menu_list: [],
        isMobile: false
      },
      progress: 0
    };
  },
  created() {
    if (document.body.clientWidth < 1000) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  mounted() {
    setTimeout(() => {
      // this.initThree('http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60fe4a066f890/78b3313eccfa3f9e9cb9c71c7c31d7b9.glb')
      this.initThree(
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/mediaLib/model/ecbc243e8695f19ff48f6537acd0cb2b.glb'
      );
    }, 1000);
  },
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    },
    initThree(url) {
      const scene = new THREE.Scene();
      const canvas = document.querySelector('#threeAdd');
      console.log(canvas);
      const renderer = new THREE.WebGLRenderer({
        canvas,
        antialias: true,
        alpha: true
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(canvas.clientWidth, canvas.clientHeight);
      const camera = new THREE.PerspectiveCamera(
        40,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
      );
      camera.position.set(5.5, 0, 2);
      var loader = new GLTFLoader();
      const dracoLoader = new DRACOLoader();
      dracoLoader.setDecoderPath('/gleditor/js/libs/draco/gltf/');
      loader.setDRACOLoader(dracoLoader);
      var mixer = null;
      loader.load(
        url,
        result => {
          const object = result.scene;
          object.position.set(0, -1, 0);
          scene.add(object);
          var clip = result.animations[0];
          mixer = new THREE.AnimationMixer(object); // 混合器，绑定目标对象
          var AnimationAction = mixer.clipAction(clip); // 对象动画执行的配置和操作
          AnimationAction.timeScale = 1; // 默认1，可以调节播放速度
          // AnimationAction.loop = THREE.LoopPingPong;
          // AnimationAction.loop = THREE.LoopOnce; //不循环播放
          AnimationAction.play(); // 开始播放
        },
        xhr => {
          this.loaded = xhr.loaded;
          this.total = xhr.total;
          this.progress = parseInt((xhr.loaded / xhr.total) * 100);
        },
        err => {
          console.error(err);
          // this.error = JSON.stringify(err)
        }
      );

      const light = new THREE.AmbientLight(0xffffff, 2); // soft white light
      scene.add(light);

      const dirLight = new THREE.PointLight(0xffffff, 0.5);
      // 光源等位置
      dirLight.position.set(4, 4, 4);
      // // 可以产生阴影
      dirLight.castShadow = true;
      dirLight.shadow.mapSize = new THREE.Vector2(10, 10);
      scene.add(dirLight);

      // const dirLight2 = new THREE.PointLight(0xffffff, 4)
      // // 光源等位置
      // dirLight2.position.set(-2, -2, -2)
      // // 可以产生阴影
      // dirLight.castShadow = true
      // dirLight.shadow.mapSize = new THREE.Vector2(10, 10)
      // scene.add(dirLight2)

      const controls = new OrbitControls(camera, renderer.domElement);
      // 创建一个时钟对象Clock
      var clock = new THREE.Clock();
      function animate() {
        controls.update();
        renderer.render(scene, camera);
        requestAnimationFrame(animate);

        if (mixer !== null) {
          // clock.getDelta()方法获得两帧的时间间隔
          // 更新混合器相关的时间
          mixer.update(clock.getDelta());
        }

        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          camera.updateProjectionMatrix();
        }
      }
      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        var width = window.innerWidth;
        var height = window.innerHeight;
        var canvasPixelWidth = canvas.width / window.devicePixelRatio;
        var canvasPixelHeight = canvas.height / window.devicePixelRatio;

        const needResize =
          canvasPixelWidth !== width || canvasPixelHeight !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }
      animate();
    }
  }
};
</script>
<style lang="less" scoped>
.introduce {
  width: 100%;
  height: 742px;
  background: #fff;
  padding-top: 1px;
  > div {
    width: 1200px;
    margin: 0 auto;
    min-height: 422px;
    position: relative;
    padding-left: 546px;
    box-sizing: border-box;
    padding-top: 1px;
    padding-bottom: 40px;
    .model {
      position: absolute;
      top: -240px;
      left: -600px;
      width: 1660px;
      height: 1150px;
      padding: 12px;
      box-sizing: border-box;
      cursor: move;
      z-index: 3;
      // background: #fff;
      // box-shadow: 1px 2px 5px 2px rgba(0, 0, 0, 0.08);
      // border: 1px solid #efefef;
    }
    .progress {
      position: absolute;
      top: 200px;
      left: 160px;
      text-align: center;
      z-index: 2;
      img {
        width: 100px;
        display: block;
        margin: 0 auto;
      }
      span {
        font-size: 24px;
        font-weight: 600;
        color: #636e8e;
        line-height: 42px;
        margin-top: 20px;
      }
    }
    .shadow {
      position: absolute;
      top: 0;
      left: -500px;
      width: 935px;
      height: 742px;
      z-index: 1;
    }
    .title {
      font-size: 42px;
      font-weight: bold;
      color: #3b4971;
      line-height: 1;
      margin-top: 119px;
    }
    .line {
      margin-top: 35px;
      border-left: 71px solid #fdd917;
      border-right: 541px solid #c2bebe;
      height: 1px;
      width: 0px;
      position: relative;
      z-index: 2;
      margin-left: -13px;
    }
    .desc {
      width: 628px;
      font-size: 24px;
      font-weight: 400;
      color: #000000;
      line-height: 60px;
      margin-top: 60px;
      text-align: justify;
      span {
        display: block;
      }
    }
  }
}
.right {
  > div {
    padding-right: 546px;
    padding-left: 56px;
    .img {
      right: 51px;
      left: auto;
    }
  }
}
@media (max-width: 1000px) {
  div.main {
    .introduce {
      width: 100%;
      height: auto;
      margin-bottom: 0px;
      padding-top: 0;
      > div {
        width: 100%;
        height: auto;
        min-height: 100%;
        padding: 80px 48px;
        box-sizing: border-box;
        margin-top: 0;
        .title {
          font-size: 36px;
          color: #3b4971;
          letter-spacing: 0;
          font-weight: 500;
          margin-top: 0;
          line-height: 1;
        }
        .line {
          margin-top: 22px;
          border-left: 170px solid #fdd917;
          border-right: 480px solid #c2bebe;
          height: 2px;
          width: 0px;
          position: relative;
          z-index: 2;
          margin-left: -13px;
        }
        .desc {
          width: 326px;
          font-size: 26px;
          line-height: 40px;
          margin-top: 40px;
          padding-left: 326px;
          box-sizing: content-box;
        }
        .model {
          width: 720px;
          height: 688px;
          top: 10px;
          left: -180px;
          bottom: auto;
          padding: 0;
          border: none;
        }
        .progress {
          top: 270px;
          left: 100px;
        }
        .shadow {
          height: 400px;
          width: 400px;
          left: -40px;
          top: 160px;
        }
      }
    }
  }
}
</style>
